module.exports = __webpack_public_path__ + "img/sfh.bd0d1d19.png";